import axios from '~/utils/request'

export function getNoticeInfoList(params) {
  return axios({
    method: 'get',
    url: '/api/NoticeInfo/GetNoticeInfoList',
    params: params
  })
}

export function getNoticeInfoUnReadCount(params) {
  return axios({
    method: 'get',
    url: '/api/NoticeInfo/GetNoticeInfoUnReadCount',
    params: params
  })
}

export function saveSYSNoticeHasRead(data) {
  return axios({
    method: 'post',
    url: '/api/NoticeInfo/SaveSYSNoticeHasRead',
    data
  })
}

export function saveSYSNoticeHasReadAll(data) {
  return axios({
    method: 'post',
    url: '/api/NoticeInfo/saveSYSNoticeHasReadAll',
    data
  })
}
